import { createFeatureActionNamer } from '../redux/action-name';

const getActionName = createFeatureActionNamer('payment');

export const ADD_PAYMENT = getActionName('ADD_PAYMENT');
export const UPDATE_PAYMENT = getActionName('UPDATE_PAYMENT');
export const DELETE_PAYMENT = getActionName('DELETE_PAYMENT');
export const SUBMIT = getActionName('SUBMIT');
